import { createContext, useContext, useCallback, useState } from 'react'

const AnnouncerContext = createContext(null)

export function AnnouncerProvider({ children }) {
  const [politeMsg, setPoliteMsg] = useState('')
  const [assertiveMsg, setAssertiveMsg] = useState('')

  const announce = useCallback((msg) => {
    setPoliteMsg('')
    setTimeout(() => setPoliteMsg(msg), 100)
  }, [])

  const alertSR = useCallback((msg) => {
    setAssertiveMsg('')
    setTimeout(() => setAssertiveMsg(msg), 100)
  }, [])

  return (
    <AnnouncerContext.Provider value={{ announce, alertSR }}>
      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {politeMsg}
      </div>
      <div
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      >
        {assertiveMsg}
      </div>
      {children}
    </AnnouncerContext.Provider>
  )
}

export function useAnnouncer() {
  const ctx = useContext(AnnouncerContext)
  if (!ctx) {
    throw new Error('useAnnouncer deve ser usado dentro de AnnouncerProvider')
  }
  return ctx
}
